export default __webpack_public_path__ + "static/media/github.e7ab8675.svg";